export enum OpsPlanningMode {	
	ForDate = 0,
	Unestimated = 10,
	All = 20,
}